import { subDays } from 'date-fns';
import { StandardPeriodType } from '../../types/filters/StandardPeriodType';

export const calculateDefaultDateRange = (
  oldestDate: Date
): { period: StandardPeriodType; range: Date[] } => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Domyślny zakres to zawsze 1 miesiąc (30 dni), niezależnie od wieku projektu.
  const startDate = subDays(today, 29);
  const selectedPeriodValue: StandardPeriodType = 'LAST_30_DAYS';

  // Jeśli oldestDate jest nowsza niż obliczony startDate, użyj oldestDate jako dolnej granicy
  const defaultOldestDate = oldestDate > startDate ? oldestDate : startDate;

  return {
    period: selectedPeriodValue,
    range: [defaultOldestDate, today],
  };
};

